import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { AxiosError } from 'axios'
import { useHistory } from 'react-router'
import { useContext, useEffect, useState } from 'react'
import { useCustomForm } from 'hooks/use-custom-form';
import EmailPassword from 'components/form-information/email-password';
import ProfileService from 'services/profile-services'
import useRedirect from 'hooks/use-redirect';
import { TextEmail, TitleEmail } from 'views/mail-verify/text.style';
import textServices from 'services/text-services';
import { Link } from 'react-router-dom';
import Otp from 'views/sign-up/components/otp';
import Button from 'components/button';
import ErrorView from 'components/error-view';
import { useSession } from '../../contexts/session-context'
import { LoaderContext } from '../../contexts/loader-context';
import { TitleLogin } from './text.style';

const auth = getAuth()

const Login = () => {
  const history = useHistory()
  const [, { setSession, setUser }] = useSession()
  const [{ url }, { redirect }] = useRedirect();
  const { setLoad } = useContext(LoaderContext)
  const { state, handleChangeState } = useCustomForm({ step: 1, email: '', password: '' })
  const [mailSent, setMailSent] = useState(null)
  const [genericError, setGenericError] = useState(null)
  const [done, setDone] = useState(false)
  const [credentials, setCredentials] = useState(null)
  const [otp, setOtp] = useState(false)
  const [dataEmail, setDataEmail] = useState(null)

  useEffect(() => {
    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: genericError !== null
      }
    })
    window.dispatchEvent(event)
  }, [genericError])

  const handleMenu = () => {
    setGenericError(null)
  }

  const handleButton = (code: number) => {
    if (code === 50) setOtp(true)
    setGenericError(null)
  }

  if (genericError) return <ErrorView buttonMenu={handleMenu} code={genericError} onRetry={handleButton} />

  const handleConfirm = async (data) => {
    setLoad(true)
    try {
      const response = await ProfileService.otpVerifyEmail({ code: data.otp, credentials })
      if (response?.status === 200) {
        setDone(true)
      }
    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      setGenericError(code)
    } finally {
      setLoad(false)
    }
  }

  const handleOnSubmit = async (data: any) => {
    try {
      setLoad(true)
      gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'LOGIN - Iniciar sesión', value: 'Email' })
      const credentials = await signInWithEmailAndPassword(auth, data.email, data.password)
      setCredentials(credentials)
      setDataEmail(data.email)
      const loginResponse = await ProfileService.signInWithEmailAndPassword({ credentials })
      setSession(credentials)
      setUser(loginResponse.data)
      const { nickName, birthday, genre, genreId } = loginResponse.data
      gtag("event", "login", {
        method: "Email"
      });
      if (url) {
        return redirect()
      } else if (!nickName || !birthday || (!genre || !genreId)) {
        return history.push('/information/update')
      } else {
        history.push('/home')
      }
    } catch (error) {
      if (error?.code) {
        return setGenericError(error.code)
      } else if ((error as AxiosError).isAxiosError) {
        return setGenericError((error as AxiosError).response?.data.code)
      }
    } finally {
      setLoad(false)
    }
  }


  if (done) return (
    <section className='w-full flex-1 flex flex-col items-center gap-4 p-7'>
      <div className='flex-1 flex flex-col items-center justify-center gap-6 w-full'>
        <TitleEmail className="text-center text-5xl font-bold uppercase mx-7 overflow-ellipsis overflow-hidden w-full">{textServices.findByText('mail/title', <>E-mail validado<br />con éxito</>)}</TitleEmail>
        <TextEmail className="din text-center mt-4 mx-7">{textServices.findByText('mail/description', <>Has confirmado con éxito tu cuenta.<br />Ya puedes ingresar</>)}</TextEmail>
      </div>
      <Link to='/login' className='w-full'>
        <Button className='uppercase'>{textServices.findByText('mail/button', 'Ingresar')}</Button>
      </Link>
    </section>
  )

  if (otp) return <Otp email={dataEmail} handleConfirm={handleConfirm} />

  return (
    <div className="mt-7 flex flex-col w-full">
      {!mailSent && <TitleLogin className="text-center text-5xl font-bold uppercase mb-7 mx-7">Inicia sesión</TitleLogin>}
      <EmailPassword
        state={state}
        handleChange={handleChangeState}
        onFormSubmitEndPoint={handleOnSubmit}
        mailSent={mailSent}
        setMailSent={setMailSent}
        setError={setGenericError}
      />
    </div>
  )
}

export default Login
